<template>
  <div class="pra">
    <div class="pra__row" v-for="(row, index) in values" :key="index">
      <span class="pra__row-tit">{{$t('pages_printer_components_printer_receipt_attributes_712')}}</span>
      <Select label-in-value @on-change="change_from_value" v-model="row.mode" style="width:100px;">
        <Option v-for="item in modes" :value="item.code" :key="item.code">{{ item.text }}</Option>
      </Select>
      <span class="pra__row-tit">{{$t('pages_printer_components_printer_receipt_attributes_713')}}</span><Input type="text" v-model="row.copies" @on-change="change_from_value" placeholder="1、2..." style="width:100px;"/>
      <span class="pra__row-tit"><i-switch true-value="on" false-value="off" v-model="row.state" size="large" @on-change="change_from_value"><span slot="open">{{$t('pages_birthday_discount_index_208')}}</span><span slot="close">{{$t('pages_birthday_discount_index_209')}}</span></i-switch></span>
    </div>
  </div>
</template>
<script>
import i18n from '../../../locales/index'

export default {
  name: 'PrinterReceiptAttributes',
  props: ['value'],
  data () {
    return {
      values: [{ copies: 1, state: 'on' }],
      modes: [
        { text: i18n.t('pages_printer_components_printer_receipt_attributes_714'), code: 'whole' },
        { text: i18n.t('pages_printer_components_printer_receipt_attributes_715'), code: 'split' },
        { text: i18n.t('pages_printer_components_printer_receipt_attributes_716'), code: 'checkout' },
        { text: i18n.t('pages_printer_components_printer_receipt_attributes_717'), code: 'label' },
        { text: i18n.t('pages_printer_components_printer_receipt_attributes_718'), code: 'prepackage' }
      ],
    }
  },
  watch: {
    value: { immediate: true, handler (val) { this.values = val || [{ copies: 1, state: 'on' }]; } }
  },
  computed: {},
  methods: {
    change_from_value () {
      console.log('this.values', this.values)
      this.$emit('input', this.values)
    },
  },
}
</script>
<style lang="scss" scoped>
.pra{
  &__row{
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    &-tit{
      margin: 0 6px;
    }
  }
}
</style>
